import { TooltipItem } from '../../../../core/types/tooltip.js';
import { MeterBarTooltip } from '../../../shared/components/meter-bar-tooltip/MeterBarTooltip.js';
import { useFormatter } from '../../../shared/context/FormatterContext.js';
import { useMeterBarChartData } from '../../context/MeterBarChartDataContext.js';

export const MeterBarChartTooltip = () => {
  const { color, name, value, tooltip } = useMeterBarChartData();
  const { formatter } = useFormatter();

  if (!tooltip) {
    return null;
  }

  const tooltipItems: TooltipItem[] = [
    {
      id: `${name}-${value}`,
      name: name ?? '',
      values: [formatter(value)],
      color: { Default: color },
    },
  ];

  return <MeterBarTooltip items={tooltipItems} />;
};

MeterBarChartTooltip['displayName'] = 'MeterBarChartTooltip';
